import { render, staticRenderFns } from "./personal-home.vue?vue&type=template&id=378d5b18&scoped=true"
import script from "./personal-home.vue?vue&type=script&lang=js"
export * from "./personal-home.vue?vue&type=script&lang=js"
import style0 from "./personal-home.vue?vue&type=style&index=0&id=378d5b18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378d5b18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378d5b18')) {
      api.createRecord('378d5b18', component.options)
    } else {
      api.reload('378d5b18', component.options)
    }
    module.hot.accept("./personal-home.vue?vue&type=template&id=378d5b18&scoped=true", function () {
      api.rerender('378d5b18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/personal-home.vue"
export default component.exports